export default showNextTariffs => {
    if ($('#show-next-tariffs').length < 1) {
        return false;
    }

    let $showNext = $('#show-next-tariffs');
    let $showAll = $('#show-all-tariffs');
    let count = $showNext.data('next-count') || 10;
    let total = $showNext.data('max');

    if (count !== 10) {
        $showNext.text(`${count} weitere Ergebnisse anzeigen`);
    }

    let removeStyle = [];

    $showNext.on('click', () => {
        let $hiddenTariffs = $('.hidden-tariff');
        removeStyle = [];

        for (var i = 0; i < count; i++) {
            $($hiddenTariffs[i]).fadeIn().removeClass('hidden-tariff');
            removeStyle.push($($hiddenTariffs[i]));

            if (parseInt($($hiddenTariffs[i]).find('.rank').text()) === total) {
                $showNext.fadeOut().remove();
                $showAll.fadeOut().remove();
            }
        }

        // Remove Style-Attrbiute for displaying flexbox correctly
        setTimeout(() => {
            removeStyle.forEach(item => {
                $(item).removeAttr('style');
            });
        }, 200);
    });

    $showAll.on('click', () => {
        let $hiddenTariffs = $('.hidden-tariff');

        $hiddenTariffs.fadeIn().removeClass('hidden-tariff');
        $showNext.fadeOut().remove();
        $showAll.fadeOut().remove();

        // Remove Style-Attrbiute for displaying flexbox correctly
        setTimeout(() => {
            $hiddenTariffs.removeAttr('style');
        }, 200);
    });
};